export type RGB = [number, number, number];

/* Maybe can find some nice copy-pasta from stack overflow or some library */
/* which lets us pass optional effects for the color; such as */
/* brightness, uuuh... and other things. */
/* TODO: find color lib. */
export const rgb = (red: number, green: number, blue: number, brightness = 1) =>
  `rgb(${red * brightness}, ${green * brightness}, ${blue * brightness})`;
